
export function priceFormatter(price, unit=' kr'){
    return new Intl.NumberFormat('sv-SE').format(price) + unit
}

export function percentage(float, unit='%') {
    return Number.parseFloat(float*100).toFixed() + unit;
}

export function thousands(int) {
    return new Intl.NumberFormat('sv-SE').format(int)
}

export function phone(phonenumber) {
     let newNumber = phonenumber.replace('+46', '0');
     let parts = newNumber.match(/^(\d{3,4})(\d{2})(\d{2})(\d{2})$/)
     if(parts === null) { return newNumber }
    return `${parts[1]}-${parts[2]} ${parts[3]} ${parts[4]}`
}